import React from 'react';

import {Button, Anchor} from '@newsela/angelou';

export const SignInLink = React.forwardRef((props, ref) => {
  SignInLink.displayName = 'SignInLink';

  return (
    <Anchor
      href="/signin"
      ref={ref}
      styleAnchorAsButton={{
        flavor: Button.flavor.solid,
        statusColor: Button.statusColor.primary,
      }}
    >
      Sign In
    </Anchor>
  );
});

export default SignInLink;
